'use client';
import { Button } from '@ahafood/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import React from 'react';
import { useCityRoutes } from '@/hooks/use-city-navigation';
import { useRouter } from '@/i18n/routing';

export default function HotDealHeader() {
  const router = useRouter();
  const routes = useCityRoutes();
  return (
    <div className="bg-white fixed top-0 inset-x-0 flex shadow-md justify-between items-center container p-0 h-12 z-[99] px-4 max-w-screen-xl w-full mx-auto">
      <Button
        variant="ghost"
        className="text-sm font-medium px-1 [&_svg]:size-5"
        onClick={() => router.push(routes.home)}
      >
        <ArrowLeft />
      </Button>
      <h1 className="text-xl font-bold">Hot deal</h1>
      <div className="w-8">{/* Placeholder for alignment */}</div>
    </div>
  );
}
